import {
  PrefixedPostfixedTextField,
  PrefixedPostfixedTextFieldProps,
} from '@components/prefixed-postfixed-text-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormPrefixedPostfixedTextFieldProps<T = unknown> = FormFieldProps<
  PrefixedPostfixedTextFieldProps,
  T
>;

export function FormPrefixedPostfixedTextField<T>(props: FormPrefixedPostfixedTextFieldProps<T>) {
  const formFieldProps = useFormField(props);

  return <PrefixedPostfixedTextField {...props} {...formFieldProps} />;
}
